import { useDropdownSource } from 'legacy/lut/hooks/useDropdownSource'
import { useStaticCrud } from 'legacy/lut/hooks/useStaticCrud'
import { useCallback, useEffect, useState } from 'react'

import { Crud } from 'core/types'

interface IValueShape {
  value: string
}

export const useAssignmentPeriodCrud = () => {
  const [data, setData] = useState<IValueShape[]>([])

  const crud = useStaticCrud({
    items: data,
    keyField: 'value',
  })

  const sorter = useCallback((crud: Crud) => {
    crud.setSort({ field: 'SortOrder', dir: 'asc' })
    return crud
  }, [])

  const crudAPeriod = useDropdownSource({
    dropdownKey: 'salesteam-mgmt-aperiod',
    decorator: sorter,
  })

  useEffect(() => {
    crudAPeriod.fetch().then((response) => {
      const lastTwo = response.items.slice(-2) as IValueShape[]
      setData(lastTwo)
    })
  }, [crudAPeriod])

  return crud
}
